import {
  PrimaryButton,
  ReactSelect,
  ReactSelectProps,
  SecondaryButton,
  TextField,
} from "@graffer-inc/console-design-kit";
import { GetQualifiedInvoiceBusinessIssuerByIdQuery } from "../../../../../graphql/generated/types";
import { emptyFunction } from "../../../../../utils/function-utils";

type Props = {
  disabledSubmitButton: boolean;
  inputBusinessIssuerGroups: ReactSelectProps<string>["value"];
  inputBusinessIssuerGroupsError: string;
  businessIssuer: GetQualifiedInvoiceBusinessIssuerByIdQuery["invoiceBusinessIssuerByID"];
  orgGroupSelectOptions: ReactSelectProps<string>["options"];
  handleOnSetRedirectToList: () => void;
  handleOnChangeGroupSearchKeyword: (input: string) => void;
  handleOnChangeBusinessIssuerGroups: (
    value: ReactSelectProps<string>["value"],
  ) => void;
  handleOnSubmit: () => Promise<void>;
};

export const QualifiedInvoiceBusinessIssuersEditForm: React.FC<Props> = ({
  disabledSubmitButton,
  inputBusinessIssuerGroups,
  inputBusinessIssuerGroupsError,
  businessIssuer,
  orgGroupSelectOptions,
  handleOnSetRedirectToList,
  handleOnChangeGroupSearchKeyword,
  handleOnChangeBusinessIssuerGroups,
  handleOnSubmit,
}) => {
  return (
    <form>
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title is-size-4">編集</h1>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <PrimaryButton
              text="更新する"
              type="button"
              disabled={disabledSubmitButton}
              onClick={handleOnSubmit}
            />
          </div>
          <div className="level-item">
            <SecondaryButton
              text="キャンセル"
              type="button"
              onClick={handleOnSetRedirectToList}
            />
          </div>
        </div>
      </div>
      <div className="field mb-4">
        <TextField
          required
          label="登録事業者名"
          description={""}
          placeholder={""}
          disabled={true}
          value={businessIssuer.name}
          onChange={emptyFunction}
        />
      </div>
      <div className="field mb-4">
        <TextField
          required
          label="登録番号"
          description={""}
          placeholder={""}
          disabled={true}
          value={businessIssuer.registrationNumber.replace(/^/, "")}
          prefixText={"T"}
          onChange={emptyFunction}
        />
      </div>
      <div className="field">
        <ReactSelect
          isClearable
          isMulti
          label={"インボイスを交付可能なグループ"}
          description={
            "登録事業者名・登録番号を参照して、インボイスを交付することが可能なグループを設定します。"
          }
          placeholder={"選択またはキーワードで検索"}
          required={false}
          value={inputBusinessIssuerGroups}
          options={orgGroupSelectOptions}
          noOptionsMessage={() => "グループがありません"}
          errorMessages={inputBusinessIssuerGroupsError}
          onInputChange={handleOnChangeGroupSearchKeyword}
          onChange={handleOnChangeBusinessIssuerGroups}
        />
      </div>
    </form>
  );
};
